import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Button } from "primereact/button";
import "../StatementTable/StatementTable.css";
import { Toast } from "primereact/toast";
import ProductService from "../../../../service/ProductService";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Chips } from "primereact/chips";

const Attributes = (props) => {
  const productService = new ProductService();

  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");
  const [filters1, setFilters1] = useState(null);
  const [newAttribute, setNewAttribute] = useState("");
  const [attributeEdited, setAttributeEdited] = useState(null);
  const [editingMode, setEditingMode] = useState(false);
  const [attributeValues, setAttributeValues] = useState([]);
  const [valuesData, setValuesData] = useState([]);
  const toast = useRef(null);

  async function fetchAttributesData() {
    try {
      setLoading(true);

      const res = await productService.getAttributes(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });

        setLoading(false);
      } else {
        setLoading(false);
        initFilters1();
        setAttributes(res.result);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;

    async function fetchAttributesData() {
      try {
        setLoading(true);

        const res = await productService.getAttributes(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );
        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });

          setLoading(false);
        } else {
          setLoading(false);
          initFilters1();
          setAttributes(res.result);
        }
      } catch (e) {
        console.log(e);
      }
    }

    fetchAttributesData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initFilters1 = () => {
    setFilters1({
      attribute: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue1("");
  };

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = { ...filters1 };
    _filters1["attribute"].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  };

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue1}
            onChange={onGlobalFilterChange1}
            placeholder={localeText("attributeSearch")}
          />
        </span>
      </div>
    );
  };

  const header1 = renderHeader1();

  async function addNewAttribute() {
    if (newAttribute.length === 0) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("pleaseFillOutField"),
        life: 6000,
      });
      return;
    }

    try {
      setLoading(true);

      const res = await productService.postAttributeRegister(
        localStorage.getItem("__extraconomy_token"),
        newAttribute,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });

        setLoading(false);
      } else {
        attributeValues.forEach(async (value) => {
          const resValues = await productService.postRegisterAttributeValue(
            localStorage.getItem("__extraconomy_token"),
            res.result.id,
            value,
            localStorage.getItem("__extraconomy_username")
          );

          if (resValues.messageCode !== 200000) {
            toast.current.show({
              severity: "error",
              summary: localeText("error"),
              detail: localeText("data").find((msg) => msg.code === resValues.messageCode).message,
              life: 6000,
            });
          }
        });

        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("attributeCreated"),
          life: 6000,
        });

        fetchAttributesData();

        setNewAttribute("");
        setAttributeValues([]);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function getValuesData(id) {
    try {
      setLoading(true);

      const res = await productService.getAttributeValues(
        localStorage.getItem("__extraconomy_token"),
        id,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
      } else {
        setValuesData(res.result);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function addNewValues() {
    if (attributeValues.length === 0) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("pleaseFillOutField"),
        life: 6000,
      });
      return;
    }

    try {
      setLoading(true);

      for (let i = 0; i < attributeValues.length; i++) {
        const resValues = await productService.postRegisterAttributeValue(
          localStorage.getItem("__extraconomy_token"),
          attributeEdited.id,
          attributeValues[i],
          localStorage.getItem("__extraconomy_username")
        );

        if (resValues.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resValues.messageCode).message,
            life: 6000,
          });
        }
      }

      toast.current.show({
        severity: "success",
        summary: localeText("success"),
        detail: localeText("valuesCreated"),
        life: 6000,
      });

      setAttributeValues([]);
      getValuesData(attributeEdited.id);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div>
      <Toast position="top-left" ref={toast} />
      <div className="card border-1 border-300">
        {props.plan === "Manager" || props.plan === "Seller" ? (
          <>
            <h3 className="my-4">{localeText("attributes")}</h3>
            <hr />

            {editingMode ? (
              <>
                <Button
                  icon="pi pi-arrow-left"
                  label={localeText("goBackToAttributeList")}
                  onClick={() => {
                    setAttributeEdited(null);
                    setEditingMode(false);
                  }}
                  className="mt-2"
                />
                <h5>
                  {localeText("listOfValues")} {attributeEdited.attribute}
                </h5>

                <ul className="mb-4 p-0 list-none">
                  <li className="mt-4">
                    <label htmlFor="new-values">{localeText("addNewValues")}</label>
                  </li>
                  <li>
                    <p className="font-bold text-xl">{localeText("attributeEnterExplanation")}</p>
                  </li>
                  <li>
                    <Chips
                      value={attributeValues}
                      onChange={(e) => setAttributeValues(e.value)}
                      className="mt-2"
                      separator=","
                      name="new-values"
                    />
                  </li>
                  <li>
                    <Button
                      label={localeText("add")}
                      className="p-button-success mt-4"
                      icon="pi pi-plus"
                      onClick={addNewValues}
                      loading={loading}
                    />
                  </li>
                </ul>

                <DataTable
                  value={valuesData}
                  paginator
                  responsiveLayout="scroll"
                  loading={loading}
                  className="mt-4"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate={localeText("showingFirstToLast")}
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                >
                  <Column field="attributeValue" header={localeText("value")}></Column>
                </DataTable>
              </>
            ) : (
              <>
                <h5>{localeText("addNewAttribute")}</h5>
                <ul className="mb-4 p-0 list-none">
                  <li>
                    <label htmlFor="new-attribute">{localeText("attributeName")}</label>
                  </li>
                  <li>
                    <InputText
                      name="new-attribute"
                      value={newAttribute}
                      className="mt-2"
                      onChange={(e) => setNewAttribute(e.target.value)}
                    />
                  </li>
                  <li className="mt-4">
                    <label htmlFor="attribute-values">{localeText("attributeValues")}</label>
                  </li>
                  <li>
                    <p className="font-bold text-xl">{localeText("attributeEnterExplanation")}</p>
                  </li>
                  <li>
                    <Chips
                      value={attributeValues}
                      onChange={(e) => setAttributeValues(e.value)}
                      className="mt-2"
                      separator=","
                      name="attribute-values"
                    />
                  </li>
                  <li className="mt-4">
                    <Button
                      label={localeText("add")}
                      className="p-button-success"
                      icon="pi pi-plus"
                      onClick={addNewAttribute}
                      loading={loading}
                    />
                  </li>
                </ul>

                <DataTable
                  value={attributes}
                  paginator
                  responsiveLayout="scroll"
                  loading={loading}
                  header={header1}
                  filters={filters1}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate={localeText("showingFirstToLast")}
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                >
                  <Column field="attribute" header={localeText("attributeName")}></Column>
                  <Column
                    header={localeText("edit")}
                    body={(rowData) => {
                      return (
                        <Button
                          icon="pi pi-pencil"
                          className="p-button p-button-rounded"
                          onClick={() => {
                            getValuesData(rowData.id);
                            setAttributeEdited(rowData);
                            setEditingMode(true);
                          }}
                        />
                      );
                    }}
                  />
                </DataTable>
              </>
            )}
          </>
        ) : (
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default Attributes;
